<div class="modal-header">
  <h5 class="modal-title">Agregar cuenta</h5>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="cancel()"
  ></button>
</div>

<div class="modal-body">
  <form (submit)="onSubmit()" [formGroup]="accoundForm">
    <div class="mb-3">
      <label>Tipo de cuenta</label>
      <ng-select
        [items]="accountTypes"
        bindLabel="label"
        bindValue="id"
        formControlName="accountType"
        class="form-control"
        [class.is-invalid]="
          accoundForm.get('accountType')?.invalid &&
          accoundForm.get('accountType')?.touched
        "
        placeholder="Seleccione tipo de cuenta"
      ></ng-select>
      @if (
        accoundForm.get('accountType')?.invalid &&
        accoundForm.get('accountType')?.touched
        ) {
        <div
          class="invalid-feedback d-block"
          >
          Tipo de cuenta es requerido.
        </div>
      }
    </div>

    <div class="mb-3">
      <label>Número de cuenta</label>
      <input
        type="text"
        formControlName="accountNumber"
        class="form-control"
        [class.is-invalid]="
          accoundForm.get('accountNumber')?.invalid &&
          accoundForm.get('accountNumber')?.touched
        "
        name="accountNumber"
        inputmode="numeric"
        pattern="[0-9]*"
        (input)="filterNumbersOnly($event)"
        sharedFormInput
        />
      @if (
        accoundForm.get('accountNumber')?.touched &&
        accoundForm.get('accountNumber')?.errors?.['required']
        ) {
        <div
          class="invalid-feedback"
          >
          El número de cuenta es requerido.
        </div>
      }
      @if (
        accoundForm.get('accountNumber')?.touched &&
        accoundForm.get('accountNumber')?.errors?.['pattern']
        ) {
        <div
          class="invalid-feedback"
          >
          Solo se permiten números.
        </div>
      }
    </div>

    <div class="mb-3">
      <label>Banco</label>
      <ng-select
        [items]="banks"
        bindLabel="description"
        bindValue="id"
        formControlName="bank"
        class="form-control"
        [class.is-invalid]="
          accoundForm.get('bank')?.invalid && accoundForm.get('bank')?.touched
        "
        placeholder="Seleccione banco"
      ></ng-select>
      @if (
        accoundForm.get('bank')?.invalid && accoundForm.get('bank')?.touched
        ) {
        <div
          class="invalid-feedback d-block"
          >
          Banco es requerido.
        </div>
      }
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-lg btn-secondary" (click)="cancel()">
        Cancelar
      </button>
      <button type="submit" class="btn btn-success btn-lg border-0 bg-colonial">
        Guardar
      </button>
    </div>
  </form>
</div>
